import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const useAuthState = () => {
  const [state, setState] = useContext(AuthContext);

  function setAuthStatus(Status: string) {
    setState(state => ({
      ...state,
      AuthStatus: Status
    }));
  }

  function setUser(User: Record<string, any>) {
    setState(state => ({
      ...state,
      User
    }));
  }

  return {
    AuthStatus: state.AuthStatus,
    setAuthStatus,
    User: state.User,
    setUser
  }

}

export default useAuthState;